import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS_ENTITY } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
import { IPreliminaryInvoice } from '../interface/invoice';
import { Entities } from '../interface/common';

interface IFetchPreliminaryInvoiceById {
  id?: string;
  relations?: string[];
  fields?: string[];
}
export const useFetchPreliminaryInvoiceById = (params: IFetchPreliminaryInvoiceById) => {
  const { id, ...queryParams } = params;
  const queryString = Object.keys(queryParams)?.length
    ? toQueryString(queryParams as QueryParamObject)
    : null;
  const invoiceUrl = `${API_URLS_ENTITY.PRELIMINARY_INVOICES}/${id}`;
  const url = queryString ? `${invoiceUrl}?${queryString}` : invoiceUrl;
  const query = useQuery<IPreliminaryInvoice, Error>({
    queryKey: ['preliminary-invoice-details', id],
    queryFn: async () => {
      const response = await get(
        url,
        {},
        {
          headers: {
            entity: Entities.PRELIMINARYINVOICE,
          },
        },
      );
      return response;
    },
    enabled: !!id,
  });

  return query;
};
